const prefix = ''

export const parserUrls = {
  'parser.list': `${prefix}/parsers`,
  'parser.view': (id = ':parserId') => `${prefix}/parsers/${id}`,
  'parser.edit': (id = ':parserId') => `${prefix}/parsers/${id}/edit`,
  'parser.add': `${prefix}/parsers/add`,
  'parser.tester': `${prefix}/parser-tester`,
}
